import CloseIcon from '@mui/icons-material/Close';
import { Button,DialogActions,DialogContent,DialogTitle,Stack,TextField,Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AttToken from "../../../helpers/attToken";
import Checklists from "../../../service/Checklists";
import queryClient from "../../../service/query";


type props = {
  open: boolean;
  handleCloseModal: Function;
  id: string;
  nome: string;
};

const formularioService = new Checklists();

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DuplicaFormulaio({ open, handleCloseModal, id, nome }: props) {
  const { t } = useTranslation('translation');
  const [nomeInput, setNomeInput] = useState<string>('');

  const { mutate, isPending } = useMutation({
    mutationKey: ['DUPLICATE_CHECKLIST'],
    mutationFn: async () => {
      toast.info(t('checklists.duplicateFormModal.pending', { nome }));
      const token = await AttToken();
      if (token) {
        const response = await formularioService.duplicaForm({ ...token, formId: id });
        return response;
      }
    },
    onSuccess: (_data) => {
      toast.success(t('custom.modelo_com_sucesso'), { toastId: 'custom.modelo_com_sucesso' });
      queryClient.refetchQueries({ queryKey: ['GET_INDEXES'] });
      handleCloseModal();
    },
    onError: (_error: Error) => {
      toast.error(t('checklists.duplicateFormModal.error'));
    }
  });

  function onChangeName(event: React.ChangeEvent<HTMLInputElement>) {
    event.preventDefault();
    setNomeInput(event.target.value);
  }

  return (
    <BootstrapDialog
      onClose={() => handleCloseModal()}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('checklists.duplicateFormModal.title')}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleCloseModal()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack direction='column' spacing={2} alignItems='center' justifyContent='flex-start' padding={2}>
          <Typography textAlign='left' fontWeight={600}>{t('checklists.duplicateFormModal.confirmDuplicateModel', { nome })}</Typography>
          <TextField
            required
            onChange={onChangeName}
            value={nomeInput}
            label={t('checklists.duplicateFormModal.confirmTypeModelName')}
            variant="outlined"
            fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => mutate()} disabled={(nome !== nomeInput) || isPending}>
          {t('yes')}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
